import { Paper, Typography } from '@mui/material';

/** Stand-in for an area whose features arrive in a later stage. */
export function Placeholder({ title, stage }: { title: string; stage: string }) {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">Coming in {stage}.</Typography>
    </Paper>
  );
}
